import React from 'react';

const stopPropagateClick = event => event.stopPropagation();

const AgreementBox = props => {
    const { containerRef, children, onOverlayClick } = props
    return (
        <div>
            <div className="overlay"></div>
            <div className="order-tab tab-agreement">
                <div className="order-tab-container" ref={containerRef} onClick={onOverlayClick}>
                    <div className="order-detail-body agreement-wrap" onClick={stopPropagateClick}>
                        <div className="agreement-box">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AgreementBox;


// WEBPACK FOOTER //
// ./src/components/agreement/AgreementBox.js